export default "__VITE_ASSET__CSf9OPUk__"